import i18n from "@microdoing/shared/i18n";
import { ResponsiveValue } from "@shopify/restyle";
import {
  Box,
  MainButton,
  MainCard,
  MainText,
  MainTitle,
  PressableOpacity,
} from "app/components/common";
import { Theme } from "app/Theme/Theme";
import React from "react";
import Modal from "react-native-modal";

export interface IValidationModalProps {
  isVisible: boolean;
  explanationText?: string;
  title?: string;
  leftButtonText?: string;
  rightButtonText?: string;
  rightButtonColor?: ResponsiveValue<keyof Theme["colors"], Theme>;
  leftButtonColor?: ResponsiveValue<keyof Theme["colors"], Theme>;
  callBackLeftButton: () => void;
  callBackRightButton: () => void;
  onClickOutside: () => void;
}

const ValidationModal = ({
  isVisible = false,
  explanationText = i18n.t("validation-modal-explanation"),
  title = i18n.t("validation-modal-title"),
  leftButtonText = i18n.t("Cancel"),
  rightButtonText = i18n.t("Confirm"),
  rightButtonColor = "brand.500",
  leftButtonColor = "neutral.500",
  callBackLeftButton = () => {},
  callBackRightButton = () => {},
  onClickOutside = () => {},
}: IValidationModalProps) => {
  return (
    <Modal
      animationInTiming={250}
      backdropTransitionOutTiming={0}
      animationOutTiming={250}
      isVisible={isVisible}
      hideModalContentWhileAnimating
      avoidKeyboard
      useNativeDriver
      onBackdropPress={onClickOutside}
    >
      <MainCard variant="cardModal">
        <Box paddingVertical="xs">
          <MainTitle variant="l6-bold" textAlign="center" marginBottom="s">
            {title}
          </MainTitle>
          <MainText variant="l3-regular" textAlign="center" marginBottom="s">
            {explanationText}
          </MainText>
        </Box>
        <Box flexDirection="row" marginTop="s">
          <Box
            flex={1}
            marginRight="xxs"
            alignItems="center"
            justifyContent="center"
          >
            <PressableOpacity onPress={callBackLeftButton}>
              <MainText
                variant="l3-medium"
                textAlign="center"
                color={leftButtonColor}
              >
                {leftButtonText}
              </MainText>
            </PressableOpacity>
          </Box>
          <Box flex={1} marginLeft="xxs">
            <MainButton
              color={rightButtonColor}
              text={rightButtonText}
              onPress={callBackRightButton}
            />
          </Box>
        </Box>
      </MainCard>
    </Modal>
  );
};

export default ValidationModal;
